import DottedBlock from './DottedBlock'

export default DottedBlock
